// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHead_root__3fNe5"};